import {createAction, props} from '@ngrx/store';
import { RaceClass } from '@app/rest-client/faxe/models/race-class';

const prefix = '[FAXE-RACE-CLASS]';

export const fetchRaceClasses = createAction(
  `${prefix} - fetch all`,
  props<{raceGuid: string;  issuerStack: string[] }>()
);

export const getRaceClasses = createAction(
  `${prefix} - get`,
  props<{raceGuid: string; issuerStack: string[] }>()
);

export const addManyRaceClasses = createAction(
  `${prefix} - add many`,
  props<{ models: RaceClass[]; issuerStack: string[] }>()
);

export const removeAllRaceClasses = createAction(
  `${prefix} - removeAll`,
  props<{ issuerStack: string[] }>()
);

export const reloadRaceClasses = createAction(
  `${prefix} - reload`,
  props<{ issuerStack: string[] }>()
);
